/**
 * Boutons flottants "Devis gratuit" et "Demander un rendez-vous" — chacun ouvre son widget
 * complet en overlay par-dessus la page courante, sans redirection. Cf.
 * snippets/devis-floating-widget.liquid pour le marquage HTML (boutons + overlays), et
 * devis-widget.js / devis-rdv-widget.js pour les widgets eux-mêmes (chargés séparément, montés
 * à la demande via window.MautoDevisWidget / window.MautoRdvWidget — jamais au chargement de
 * la page).
 *
 * Passerelle "Prendre rendez-vous" (étape Estimation du widget de devis, cf. devis-widget.js
 * handoffToRdv) : ce fichier écoute l'événement DOM `mauto:open-rdv-widget`, ferme l'overlay
 * devis s'il est ouvert (le widget de devis peut aussi tourner inline hors overlay — hero ou
 * page /devis-en-ligne — auquel cas il n'y a rien à fermer ici) et ouvre l'overlay RDV avec les
 * données pré-remplies transmises dans `event.detail`.
 *
 * Contexte prestation par page (bouton "Devis gratuit" uniquement) : chaque fiche prestation
 * peut poser un `#mauto-sticky-context` (section custom-liquid, cf. templates/page.*.json)
 * avec data-prestation-key/-label/-price-label. Si présent, le bouton affiche le nom (et le
 * prix s'il est connu) de la prestation, et le widget s'ouvre directement dessus au lieu de
 * l'étape 1 générique — même clé que `data-prestation-key` côté widget inline
 * (cf. devis-widget.js), donc doit exister côté /api/pricing (sync-server DEFAULT_PRICING).
 */
(function () {
  'use strict';

  function getPrestationContext() {
    var ctx = document.getElementById('mauto-sticky-context');
    if (!ctx) return null;
    var key = ctx.getAttribute('data-prestation-key');
    if (!key) return null;
    return {
      key: key,
      label: ctx.getAttribute('data-prestation-label') || '',
      priceLabel: ctx.getAttribute('data-price-label') || '',
    };
  }

  function applyPrestationContextToFab(fab, context) {
    if (!fab || !context || !context.label) return;
    var labelEl = fab.querySelector('.mauto-devis-fab-label');
    if (!labelEl) return;
    labelEl.textContent = 'Devis ' + context.label + (context.priceLabel ? ' — ' + context.priceLabel : '');
  }

  function wireFab(fabId, overlayId, closeId, mount) {
    var fab = document.getElementById(fabId);
    var overlay = document.getElementById(overlayId);
    var closeBtn = document.getElementById(closeId);
    var widgetContainer = overlay ? overlay.querySelector('[data-mauto-devis-widget], [data-mauto-rdv-widget]') : null;
    if (!fab || !overlay || !closeBtn || !widgetContainer) return null;

    function openOverlay(options) {
      overlay.hidden = false;
      document.body.classList.add('mauto-devis-overlay-open');
      // Remonté à chaque ouverture : repart d'un parcours neuf (pas d'état résiduel d'une
      // ouverture précédente), cf. initWidget() qui vide et reconstruit le conteneur.
      mount(widgetContainer, options);
    }

    function closeOverlay() {
      overlay.hidden = true;
      document.body.classList.remove('mauto-devis-overlay-open');
      widgetContainer.innerHTML = '';
    }

    fab.addEventListener('click', function () { openOverlay(); });
    closeBtn.addEventListener('click', closeOverlay);
    // Clic sur le fond assombri (en dehors de la coquille du widget) = fermer.
    overlay.addEventListener('click', function (ev) {
      if (ev.target === overlay) closeOverlay();
    });

    return { open: openOverlay, close: closeOverlay };
  }

  function init() {
    var prestationContext = getPrestationContext();

    wireFab('mauto-devis-fab', 'mauto-devis-overlay', 'mauto-devis-overlay-close', function (container) {
      if (prestationContext) container.setAttribute('data-prestation-key', prestationContext.key);
      if (window.MautoDevisWidget) window.MautoDevisWidget.initWidget(container);
    });
    applyPrestationContextToFab(document.getElementById('mauto-devis-fab'), prestationContext);
    var rdvFab = wireFab('mauto-devis-rdv-fab', 'mauto-rdv-overlay', 'mauto-rdv-overlay-close', function (container, options) {
      if (window.MautoRdvWidget) window.MautoRdvWidget.initWidget(container, options);
    });

    document.addEventListener('mauto:open-rdv-widget', function (ev) {
      var devisOverlay = document.getElementById('mauto-devis-overlay');
      if (devisOverlay && !devisOverlay.hidden) {
        devisOverlay.hidden = true;
        document.body.classList.remove('mauto-devis-overlay-open');
        var devisContainer = devisOverlay.querySelector('[data-mauto-devis-widget]');
        if (devisContainer) devisContainer.innerHTML = '';
      }
      if (rdvFab) rdvFab.open(ev.detail);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
